export default {

	init() {
		const htmlElement = document.documentElement;
		htmlElement.classList.remove('no-js');
		htmlElement.classList.add('js');

		this.scrollbarWidth();

		this.setAllExternalLinksToOpenInNewTab();

		//Fix for form styles
		document.addEventListener("DOMContentLoaded", function(event) {
			var linkNode = document.querySelector('link[href*="https://merceradvisors.tfaforms.net/uploads/themes/theme-23.css"]');
			if(linkNode !== null) linkNode.remove();
		});

		$('.sh-block-wrapper.cta a[href="#scrolltotop"]').on('click', function(e){
			e.preventDefault();
			window.scrollTo(0, 0);
		});

		setTimeout(function(){
			$('a[href="#contact-drawer"]').each(function(){
				$(this).attr('href', '#');
				$(this).attr('data-bs-toggle', 'offcanvas');
				$(this).attr('data-bs-target', '#offcanvasBottom2V3');
				$(this).attr('aria-controls', 'offcanvasBottom');
			});
		}, 1000);

		if($('body').hasClass('single-landing-page')) {
			setTimeout(function(){
				$('a').each(function(){
					if(!$(this).attr('href').includes('#')) {
						$(this).attr('target', '_blank');
					}
				});
			}, 1000);
		}

		const currentUrl = window.location.href;
		if(currentUrl.includes('#advisor-slider-updated')) {
			setTimeout(function(){
				console.log('scroll');
				const scrollTop = $("#advisor-carousel-slider").offset().top - 400;
				$(document.documentElement).animate({
					scrollTop: scrollTop
				}, 200);
			}, 800);
		}
	},

	scrollbarWidth() {
		let scrollbarWidth = window.innerWidth - document.body.clientWidth;
		let root = document.querySelector(':root');

		root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
	},

	getPrefersReducedMotion() {
		return window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;
	},

	getViewportWidth() {
		return Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		)
	},

	isMobile() {
		return window.matchMedia('(max-width: 1023px)').matches;
	},

	setAllExternalLinksToOpenInNewTab() {
		const links = document.getElementsByTagName('a');
		for(var i = 0; i < links.length; i++) {
			const href = links[i].href;
			
			if(href.length > 5) {
				const hrefHostname = new URL(links[i].href).hostname;

				const matches = (hrefHostname == window.location.hostname || 'www.' + hrefHostname == window.location.hostname || hrefHostname == 'www.' + window.location.hostname);
				if(!matches) links[i].target = '_blank';
			}
		}		
	}

};
